module.exports = __webpack_public_path__ + "img/sw3-b2.ab95b5aa.jpg";